import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import SoundConfig from "../model/SoundConfig";

export default class InitSoundConfigTask extends Task {
    /**
     * @constructor
     * @param {AssetLibrary} assetLibrary 
     * @param {SoundConfig} soundConfig 
     */
    constructor(assetLibrary, soundConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const jsonObj = assetLibrary.getAsset("sound-config");
            soundConfig.setPropertiesFromObject(jsonObj);
            callback(this);
        }
    }
}